import React from "react";

import { InputAdornment, TextField } from "@mui/material";
import { useSearchBox } from "react-instantsearch";

import SearchIcon from "../Icons/SearchIcon";

const SearchBox: React.FC = () => {
  const { query, refine } = useSearchBox();

  return (
    <TextField
      placeholder="Search..."
      size="small"
      onChange={(e) => refine(e.target.value)}
      autoFocus
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="inherit" />
          </InputAdornment>
        ),
      }}
    />
  );
};
export default SearchBox;
